const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      // [2026-08-14] Keep sold-out cards at the bottom ACROSS appended pages.
      //
      // This used to be a blind .append() of the next page's cards. Each page is
      // internally demoted by main-collection-product-grid.liquid (in-stock first,
      // sold-out last), but appending page 2 whole put page 1's sold-out block ABOVE
      // page 2's in-stock products. On /collections/all-products (130 products, 30 per
      // page) a shopper met sold-out cards mid-list at roughly positions 30, 60, 90 and
      // 120, so "sold out renders last" was simply untrue on the six largest collections.
      //
      // Now the incoming cards are split on the same .collection-product-card--sold-out
      // class the grid stamps, in-stock cards are spliced in before the first sold-out
      // card already on the page, and sold-out cards are appended after it. The sold-out
      // block stays contiguous at the end however many pages are loaded.
      const $grid = $('.load-more-grid');
      const $incoming = $(responseHTML).find('.load-more-grid').children();
      const $incomingSoldOut = $incoming.filter('.collection-product-card--sold-out');
      const $incomingInStock = $incoming.not('.collection-product-card--sold-out');
      const $firstSoldOut = $grid.children('.collection-product-card--sold-out').first();

      if ($firstSoldOut.length) {
        $firstSoldOut.before($incomingInStock);
      } else {
        $grid.append($incomingInStock);
      }
      $grid.append($incomingSoldOut);

      colorSwatches();
    },
    complete: function() {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      } 
    }
  })
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();